import { repayment } from '@/utils/dictionary'

export const Repayment = (value: string | number) => {
  const result = repayment.find(item => item.value === value + '')
  return result ? result.label : ''
}
